module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/plus-c641c69fe95278c3c1fbf1fecedcd086.svg";